var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16789 15.6674H15.8346M5.83452 12.334C4.79475 12.334 3.79756 11.9389 3.06234 11.2357C2.32711 10.5324 1.91406 9.57856 1.91406 8.584C1.91406 7.58944 2.32711 6.63561 3.06234 5.93235C3.79756 5.22909 4.79475 4.834 5.83452 4.834C6.08009 3.73998 6.79849 2.77857 7.83167 2.16126C8.86486 1.54396 10.1282 1.32132 11.3438 1.54233C12.5594 1.76335 13.6276 2.40991 14.3135 3.33977C14.9994 4.26964 15.2468 5.40665 15.0012 6.50067H15.8345C16.6081 6.50067 17.3499 6.80796 17.8969 7.35494C18.4439 7.90192 18.7512 8.64379 18.7512 9.41733C18.7512 10.1909 18.4439 10.9327 17.8969 11.4797C17.3499 12.0267 16.6081 12.334 15.8345 12.334H5.83452Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFog);
export default __webpack_public_path__ + "static/media/Fog.10578d6c1afe61d98d780a87b76e3186.svg";
export { ForwardRef as ReactComponent };